import React, {useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCompanyDetailList } from "../../store/Slice/companyDetailSlice";
import { getSocialDetailList } from "../../store/Slice/socialDetailSlice";

const Footer = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false); // Track image load state
  const dispatch = useDispatch();
  const { companyDetailData } = useSelector((state) => state.companyDetailList);
  const { socialDetailData } = useSelector((state) => state.socialDetailList);

  React.useEffect(() => {
    if (!companyDetailData) {
      dispatch(
        getCompanyDetailList({
          eConfig: "Company",
        })
      );
    }
  }, [dispatch, companyDetailData]);

  React.useEffect(() => {
    if (!socialDetailData) {
      dispatch(
        getSocialDetailList({
          eConfig: "Social",
        })
      );
    }
  }, [dispatch, socialDetailData]);

  const getCompanyDetail = (key) =>
    companyDetailData?.data?.find((item) => item.vName === key)?.vValue;

  const footerDescription = getCompanyDetail("FOOTER_DESCRIPTION");
  const copyRightText = getCompanyDetail("COPYRIGHTED_TEXT");
  const footerNumber = getCompanyDetail("COMPANY_NUMBER");
  const footerEmail = getCompanyDetail("COMPANY_EMAIL");

  const getSocialLink = (key) =>
    socialDetailData?.code === 200
      ? socialDetailData.data?.find((item) => item.vName === key)?.vValue
      : null;

  const facebookLink = getSocialLink("SOCIAL_FACEBOOK");
  const twitterLink = getSocialLink("SOCIAL_TWITTER");
  const instagramLink = getSocialLink("SOCIAL_INSTAGRAM");

  return (
    <section
      className="footer"
      // style={{ backgroundImage: "url('/assets/images/footer-bg.jpg')" }}
      // style={{ backgroundImage: "url('/assets/images/footer-bg.webp')" }}
      style={{ position: "relative", overflow: "hidden" }}

    >
    <img
          src={'/assets/images/footer-bg.webp'}
          alt="MopForce Banner"
          fetchPriority="high"
          decoding="async"
          loading="eager"
          onLoad={() => setIsImageLoaded(true)} // Image loaded callback
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            filter: isImageLoaded ? "none" : "blur(10px)", // Apply blur initially
            transition: "filter 0.3s ease-out", // Smooth transition once image is loaded
          }}
        />
      <div className="container">
        <div className="top-footer">
          <div className="row">
            <div className="col-xl-3 col-lg-12 col-md-12 col-sm-7">
              <div className="footer-logoDiv">
                <img
                  className="header-logo footer-logo"
                  // width="216"
                  width="172.8"
                  height="36.43"
                  // height="50"
                  // src="/assets/images/logo.png"
                  src="/assets/images/logo.webp"
                  alt="Logo"
                  loading="lazy"
                />
                <p>{footerDescription}</p>
                <div className="footer-socialDiv">
                  Follow Us{" "}
                  <ul className="footer-ullist">
                    {socialDetailData &&
                      socialDetailData.code === 200 &&
                      socialDetailData.data &&
                      socialDetailData.data.length > 0 && (
                        <>
                          {facebookLink ? (
                            <li>
                              <Link
                                className="footer-contact"
                                to={facebookLink}
                                aria-label="facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="35"
                                  height="36"
                                  viewBox="0 0 35 36"
                                  fill="none"
                                >
                                  <path
                                    d="M21.2422 19.0264H18.3125V27.7764H14.4062V19.0264H11.2031V15.4326H14.4062V12.6592C14.4062 9.53418 16.2812 7.77637 19.1328 7.77637C20.5 7.77637 21.9453 8.0498 21.9453 8.0498V11.1357H20.3438C18.7812 11.1357 18.3125 12.0732 18.3125 13.0889V15.4326H21.7891L21.2422 19.0264Z"
                                    fill="white"
                                  />
                                  <rect
                                    x="0.5"
                                    y="0.776367"
                                    width="34"
                                    height="34"
                                    rx="4.5"
                                    stroke="white"
                                  />
                                </svg>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {twitterLink ? (
                            <li>
                              <Link
                                className="footer-contact"
                                to={twitterLink}
                                aria-label="twitter"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="35"
                                  height="36"
                                  viewBox="0 0 35 36"
                                  fill="none"
                                >
                                  <path
                                    d="M8.04679 8.27637L15.4571 18.1846L8 26.2404H9.67829L16.2069 19.1874L21.4819 26.2404H27.1932L19.366 15.7749L26.3069 8.27637H24.6287L18.6161 14.772L13.7581 8.27637H8.04679ZM10.5148 9.51259H13.1386L24.7247 25.004H22.101L10.5148 9.51259Z"
                                    fill="white"
                                  />
                                  <rect
                                    x="0.5"
                                    y="0.776367"
                                    width="34"
                                    height="34"
                                    rx="4.5"
                                    stroke="white"
                                  />
                                </svg>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                          {instagramLink ? (
                            <li>
                              <Link
                                className="footer-contact"
                                to={instagramLink}
                                aria-label="instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <svg
                                  className="footer-contactsvg"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="35"
                                  height="35"
                                  viewBox="0 0 35 35"
                                  fill="none"
                                >
                                  <path
                                    d="M22.0625 12.9375V12.9488M8 13.5C8 12.3065 8.47411 11.1619 9.31802 10.318C10.1619 9.47411 11.3065 9 12.5 9H21.5C22.6935 9 23.8381 9.47411 24.682 10.318C25.5259 11.1619 26 12.3065 26 13.5V22.5C26 23.6935 25.5259 24.8381 24.682 25.682C23.8381 26.5259 22.6935 27 21.5 27H12.5C11.3065 27 10.1619 26.5259 9.31802 25.682C8.47411 24.8381 8 23.6935 8 22.5V13.5ZM13.625 18C13.625 18.8951 13.9806 19.7536 14.6135 20.3865C15.2464 21.0194 16.1049 21.375 17 21.375C17.8951 21.375 18.7536 21.0194 19.3865 20.3865C20.0194 19.7536 20.375 18.8951 20.375 18C20.375 17.1049 20.0194 16.2464 19.3865 15.6135C18.7536 14.9806 17.8951 14.625 17 14.625C16.1049 14.625 15.2464 14.9806 14.6135 15.6135C13.9806 16.2464 13.625 17.1049 13.625 18Z"
                                    stroke="white"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <rect
                                    x="0.5"
                                    y="0.5"
                                    width="34"
                                    height="34"
                                    rx="4.5"
                                    stroke="white"
                                  />
                                </svg>
                              </Link>
                            </li>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                  </ul>
                </div>
                <a href="https://chcassociation.org/">
                  <img
                    className="accreditation-icon"
                    width="86"
                    height="100"
                    // src="/assets/images/White_Transparent_Accreditation-white 1.png"
                    src="/assets/images/White_Transparent_Accreditation-white 1.webp"
                    alt="Logo"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            {/* <div className="col-xl-3 col-lg-4 col-md-4 col-sm-5">
              <h3 className="footer-title">My Account</h3>
              <ul className="footer-list">
                <li>
                  <Link to="/login" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Register
                  </Link>
                </li>
              </ul>
            </div> */}
            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-7">
              <h3 className="footer-title">Explore MopForce</h3>
              <ul className="footer-list">
                <li>
                  <Link
                    to="/"
                    className="footer-link"
                    // onClick={homeLinkClicked}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                {/* <li>
                  <Link to="/" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Services
                  </Link>
                </li> */}
                <li>
                  <Link to="/blogs" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/frequently-asked-questions"
                    className="footer-link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    FAQ
                  </Link>
                </li>
                {/* <li>
                  <Link to="/join-us" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Become A Pro
                  </Link>
                </li> */}
                <li>
                  <Link to="/join-us" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Join Us
                  </Link>
                </li>
                <li>
                  <Link to="/commercial" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    MopForce Commercial
                  </Link>
                </li>
                <li>
                  <Link to="/careers" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Careers
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-5">
              <h3 className="footer-title">Help & Legal</h3>
              <ul className="footer-list">
                <li>
                  <Link to="/privacy-policy" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="footer-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="3"
                      viewBox="0 0 16 3"
                      fill="none"
                    >
                      <path
                        d="M1 1.27637H15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Contact Us
                  </Link>
                  <div style={{ paddingLeft: "29px" }}>
                    <p
                      style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                    >
                      Email:
                      <Link
                        to={`mailto:${footerEmail}`}
                        className="footer-link"
                        style={{ marginBottom: "0px" }}
                      >
                        {footerEmail}
                      </Link>
                    </p>
                    <p
                      style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                    >
                      Phone:
                      <Link
                        to={`tel:${footerNumber}`}
                        style={{ marginBottom: "0px" }}
                        className="footer-link"
                      >
                        {footerNumber}
                      </Link>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-footer">
        <p className="copy-righttext mb-0">{copyRightText}</p>
      </div>
    </section>
  );
};

export default Footer;
